import routes from '@/config/routes';
import { v3Get } from '../axios.instance.V3';
import { ApiResponse } from '../types';

export const getAllAdSources = (): ApiResponse => v3Get(routes.backendUrl.advertising.sources);
